import {
  PaymentElement,
  useElements,
  useStripe
} from "@stripe/react-stripe-js";
import { logger } from "logger";
import { useState } from "react";
import { toast } from "react-toastify";
import { Button, ButtonVariant } from "shared/components";
import { getErrorMessage } from "utils/error";

export const CheckoutForm = ({
  checkout
}: {
  checkout: (paymentIntentId: string) => Promise<unknown>;
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);

  return (
    <form
      onSubmit={async (e) => {
        e.preventDefault();
        if (!stripe || !elements || loading) return;
        setLoading(true);
        try {
          const res = await stripe.confirmPayment({
            elements,
            redirect: "if_required"
          });
          if (res.error) {
            logger.error(res.error.code || "", res.error);
            throw new Error(res.error.message);
          }
          if (res.paymentIntent.id)
            checkout(res.paymentIntent.id)
              .catch((err) => {
                toast.error(
                  getErrorMessage(err) ||
                    "An error occurred while processing your payment."
                );
              })
              .finally(() => {
                setLoading(false);
              });
          else throw new Error("No payment intent");
        } catch (err: unknown) {
          toast.error(getErrorMessage(err));
          setLoading(false);
        }
      }}
    >
      <div>
        <PaymentElement
          options={{
            layout: "tabs"
          }}
        />
      </div>

      <Button
        className="mt-4 w-full !text-base"
        loading={loading}
        type="submit"
        variant={ButtonVariant.PRIMARY}
      >
        Pay with Card
      </Button>
    </form>
  );
};
